import _ from 'underscore';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import title_helper from '@/lib/title_helper';

export default function(options){
  // Use this global channel for handling app requests
  var globalCh = Radio.channel('global');
  var apiCh = Radio.channel('api');
  var routerCh = Radio.channel('router');
  /**
   * Get the proper route for a given endpoint.
   * Note that this requires keeping in sync with whatever is
   * defined on the router, since there is no router.routeFor
   * or aything rails-ish like that. Consider this
   * better-than-nothing and an opportunity to refactor later.
   */
  var route_for = {
      login: function() {
          title_helper.default();
          return '/login';
      },
      reset_password: function(token) {
          title_helper.default();
          return route_for.login()
               + '/reset_password'
               + (token ? '/' + token : '');
      },
      forgot_password: function() {
          title_helper.default();
          return route_for.login() + '/forgot_password';
      },
      verify: function() {
          title_helper.default();
          return route_for.login() + '/verify';
      },
      home: function() {
          return '/ide';
      },
      dashboard: function(account) {
          var account_name = encodeURIComponent(account.get('username'));
          return route_for.home() + '/' + account_name + '/dashboard';
      },
      products: function(account) {
          title_helper.set(['Products']);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/products';
      },
      product: function(product) {
          return route_for.home() + '/products/' + product.id;
      },
      device: function(device) {
          title_helper.set(['Device', device.get('mac_address')]);
          return route_for.home() + '/devices/' + device.id;
      },
        /*
         * the product_devicegroups set_location method takes the type of devicegroup, and
         *  returns the simplified name in the url.
         *    1) the string '_devicegroup' is removed from type: ex 'development_devicegroup'
         *       now becomes 'development'. 'pre_factoryfixture_devicegroup' to 'pre_factoryfixture'
         *    2) next, type has 'fixture' removed to simplify the factory names, 'pre_factoryfixture'
         *       now becomes 'pre_factory'.
         *    3) lastly 'pre_' is replaced by 'test_', for example taking 'pre_production' -> 'test_production'
         *    4) after it's all ready, we can display that as it's part in the url
         */
        product_devicegroups: function(product, type) {
            title_helper.set([product.get('name')]);
                      type = type.replace('_devicegroup', '');
                      type = type.replace('fixture', '');
                      type = type.replace('pre_', 'test_');
                      switch (type) {
                          case 'production':
                          type = 'production';
                      break;
            case 'factory':
                type = 'factory';
                break;
            case 'development':
                type = 'development';
                break;
            case 'test_production':
                type = 'test_production';
                break;
            case  'test_factory':
                type = 'test_factory';
          }

          return route_for.product(product) + '/devicegroups/' + type;
      },
      productDevicegroup: function(product, devicegroup){
          title_helper.set([devicegroup.get('name')]);
          return route_for.product(product) + '/devicegroups/' + devicegroup.id;
      },
      devices: function(account) {
          title_helper.set(['Devices']);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/devices';
      },
      my_devices: function() {
          title_helper.set(['My devices']);
          return route_for.home() + '/my_devices';
      },
      blinkup: function() {
          title_helper.set(['Blinkup']);
          return route_for.home() + '/blinkup';
      },
      product_devices: function(product){
          title_helper.set([product.get('name')]);
          return route_for.product(product) + '/devices';
      },
      devicegroup_devices: function(product, devicegroup, device){
          var route = route_for.productDevicegroup(product, devicegroup) + '/devices';
          title_helper.set([devicegroup.get('name')]);
          if (device) {
              return route + '/' + device.id;
          }
          return route;
      },
      collaborators: function(account) {
          title_helper.set(['Collaborators', account.get('username')]);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/collaborators';
      },
      collaborators_profile: function(account, collaborator) {
          return route_for.collaborators(account) + '/' + collaborator.get('username');
      },
      profile: function(account) {
          title_helper.set(['Profile', account.get('username')]);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/profile';
      },
      billing: function(account) {
          title_helper.set(['Account Billing', account.get('username')]);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/billing';
      },
      invoice: function(account, invoice) {
          title_helper.set(['Invoice ', invoice.id]);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/invoice/' + invoice.id;
      },
      devicegroups: function(product) {
          title_helper.set([product.get('name')]);
          return route_for.product(product) + '/devicegroups/production';
      },
      factories: function(product, devicegroup) {
          title_helper.set([devicegroup.get('name'), product.get('name')]);
          return route_for.product(product) + '/factories/' + devicegroup.id;
      },
      factory_code_history: function (product, devicegroup) {
          title_helper.set([devicegroup.get('name'), product.get('name')]);
          return route_for.factories(product, devicegroup) + '/code_history';
      },
      devicegroup_code_history: function (product, devicegroup) {
          title_helper.set([devicegroup.get('name')]);
          return route_for.productDevicegroup(product, devicegroup) + '/code_history';
      },
      devicegroup_deployment: function (product, devicegroup, deployment, device) {
          var route = route_for.productDevicegroup(product, devicegroup);
          title_helper.set([devicegroup.get('name'), product.get('name')]);
          route = route + '/deployments/' + deployment.id;
          if ( device ) {
              return route + '/devices/' + device.id;
          }
          return route;
      },
      devicegroup_draft: function (product, devicegroup, device) {
          var route = route_for.productDevicegroup(product, devicegroup);
          title_helper.set([devicegroup.get('name'), product.get('name')]);
          route = route + '/draft';
          if ( device ) {
              return route + '/devices/' + device.id;
          }
          return route;
      },
      login_keys: function(account) {
          title_helper.set(['Login keys', account.get('username')]);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/login_keys';
      },
      mfa: function(account) {
          title_helper.set(['Multi-Factor Authentication', account.get('username')]);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/mfa';
      },
      notifications: function(account) {
          title_helper.set(['Notifications', account.get('username')]);
          return route_for.home() + '/' + encodeURIComponent(account.get('username')) + '/notifications';
      }
  };
  function get_route(route_key) {
      // Make a copy of arguments so we can treat it like an Array!
      var args = Array.prototype.slice.call(arguments);
      args = args.slice(1);
      return route_for[route_key].apply(this, args);
  }
  routerCh.reply('route', get_route);
  /**
   * Get a path for the location bar,
   * given a defined key in route_for and an object which matches,
   * and set the browser location.
   * @param String route_key corresponds to an item in the route_for object
   * @param Object [Optional] depending on the specified route, zero or more items may be passed
   */
  function set_location() {
      var url = get_route.apply(this, arguments);
      routerCh.request('navigate', url);
  }
  // make get_canonical_url available on the router channel
  routerCh.reply('set_location', set_location);

  function parse_query_params(query) {
      var params = {};
      if (!(query && query.length)) return params;
      var fields = query.split('&');
      fields.forEach(function(field){
          var parts = field.split('=');
          var key = parts[0];
          var value = parts[1] || null;
          params[key] = value;
      });
      return params;
  }

    function ensure_account_loaded_by_name(account_name) {
        var accounts = apiCh.request('account');
        var account = accounts.findWhere({ username: account_name });

        if (!account) {
            globalCh.request('not_found', 'Unknown account ' + account_name);
            return Promise.reject();
        }

        return globalCh.request('ensure_account_loaded', account);
    }

    function load_devicegroup(devicegroup_id) {
        return apiCh.request('promise', 'development_devicegroup', devicegroup_id);
    }

    function load_product(product_id) {
        function error() {
            globalCh.request('not_found', "Couldn't find product " + product_id);
        }
        var products = apiCh.request('product');
        return products.lookup(product_id).then(set_active_account).fail(error);
    }

    function set_active_account(product){
        var globalCh = Radio.channel('global');
        var deferred = $.Deferred();
        // Don't bother fetching the relationships if they're already there
        if (product && product.rel.get('owner')) {
            globalCh.request('setActiveAccount', product.rel.get('owner')).done(()=>{
                deferred.resolve(product);
            });
        // If we don't have the relationships, though, grab them
        } else if (product && !product.rel.get('owner')) {
            product.rel.fetch_all().done(function(){
                    globalCh.request('setActiveAccount', product.rel.get('owner')).done(()=>{
                        deferred.resolve(product);
                    });
            });
        }
        return deferred.promise();
    }

    var IdeRouter = Backbone.Router.extend({
        initialize: function(){
            // Listen for navigate commands and change the browser's url
            routerCh.reply('navigate', _.bind(this.onSetUrl, this));
        },
        /**
         * onSetUrl
         *
         * Replaces 'nav' event in most cases, and should be triggered
         * only by the controller.
         */
        onSetUrl: function(url) {
            this.navigate(url);
            // send analytics router event if enabled
            var app_features = globalCh.request('app_options', 'features');
            var ga_account = app_features && app_features.ga_account;
            if (ga_account){
                window.ga('send', 'pageview', url);
            }
        },
        routes : {
            'billing'                                   : 'billing_redirect',
            '(/)'                                       : 'home',
            'ide(/)'                                    : 'home',
            'ide/my_devices'                            : 'my_devices',
            'ide/blinkup'                               : 'blinkup',
            'ide/devicegroup/:id(/)'                    : 'find_devicegroup_dashboard',
            'ide/:account_name(/)'                      : 'home',
            'ide/:account_name/login_keys(/)'           : 'login_keys',
            'ide/:account_name/mfa(/)'                  : 'mfa',
            'ide/:account_name/notifications(/)'        : 'notifications',
            'ide/:account_name/profile(/)'              : 'profile',
            'ide/:account_name/dashboard(/)'            : 'dashboard',
            'ide/:account_name/products(/)'             : 'products',
            'ide/change_email/:token'                   : 'change_email',
            'ide/devices/:device_id'                    : 'device',
            'ide/products/:product_id'                  : 'product',
            'ide/products/:product_id/devicegroups(/)'                            : 'devicegroups',
            'ide/products/:product_id/devicegroups/:type'                         : 'product_devicegroups',
            'ide/products/:product_id/devicegroups/:devicegroup_id(/)'            : 'devicegroup_dashboard',
            'ide/products/:product_id/devicegroups/:devicegroup_id/draft(/)'      : 'devicegroup_draft',
            'ide/products/:product_id/devicegroups/:devicegroup_id/draft/devices/:device_id': 'devicegroup_draft',
            'ide/products/:product_id/devicegroups/:devicegroup_id/deployments/:deployment_id(/)': 'devicegroup_deployment',
            'ide/products/:product_id/devicegroups/:devicegroup_id/deployments/:deployment_id/devices/:device_id(/)': 'devicegroup_deployment',
            'ide/products/:product_id/devicegroups/:devicegroup_id/devices/:device_id': 'product_devicegroup_devices',
            'ide/products/:product_id/devicegroups/:devicegroup_id/devices'     : 'product_devicegroup_devices',
            'ide/products/:product_id/factories/'                               : 'factories',
            'ide/products/:product_id/factories/:devicegroup_id/code_history'   : 'factory_code_history',
            'ide/products/:product_id/devicegroups/:devicegroup_id/code_history' : 'devicegroup_code_history',
            'ide/:account_name/devices(/)'              : 'account_devices',
            'ide/:account_name/collaborators'           : 'collaborators',
            'ide/:account_name/collaborators/:username' : 'collaborators_profile',
            'ide/:account_name/billing(/)'              : 'billing',
            'ide/:account_name/invoice/:id'             : 'invoice',
            'login/reset_password/:token'               : 'reset_password',
            'login/reset_password/*'                    : 'reset_password',
            'login/forgot_password'                     : 'forgot_password',
            'login/verify'                              : 'verify',
            'login(/)*path'                             : 'login',
            '*path'                                     : 'not_found'
        },
        billing_redirect: function() {
            window.location = '/billing.html';
        },
        home: function(account_name) {
            if (account_name){
                ensure_account_loaded_by_name(account_name).then(function() {
                    globalCh.request('home');
                });
            } else {
                globalCh.request('home');
            }
        },
        dashboard: function(account_name) {
            ensure_account_loaded_by_name(account_name).then(function() {
                globalCh.request('dashboard');
            });
        },
        profile: function() {
            // We need this so that invalid accounts are shownn as 404
            var primary = globalCh.request('primary_account');
            ensure_account_loaded_by_name(primary.get('username')).then(() => {
                globalCh.request('show_profile', primary);
            });
        },
        device: function(device_id) {
            var devices = apiCh.request('device');

            function success(device) {
                globalCh.request('show_device', device);
            }
            function error() {
                globalCh.request('not_found', "Couldn't find device " + device_id);
            }
            devices.lookup(device_id)
                .done(success)
                .fail(error)
            ;
        },
        products: function(account_name) {
            ensure_account_loaded_by_name(account_name).then(function() {
                globalCh.request('showProducts');
            });
        },
        product: function(product_id) {
            load_product(product_id)
            .then(function(product) {
                globalCh.request('showProducts');
            });
        },
        product_devices: function(product_id, type) {
            if (type){
                type = type + '_device';
            }

            load_product(product_id)
            .then(function(product) {
                globalCh.request('show_devices', { product: product, type: type });
            });
        },
        product_devicegroups: function(product_id, type) {
            var self = this;
            load_product(product_id)
                .then(function (product) {
                    if (!type) {
                        console.warn("Unknown devicegroup type: %s", type);
                        type = 'development_devicegroup';
                    }

                    type = type.replace('_devicegroup', '');
                    type = type.replace('fixture', '');
                    type = type.replace('pre_', 'test_');
                    switch (type) {
                        case 'production':
                            type = 'production_devicegroup';
                            globalCh.request('show_production_devicegroups', product, type);
                            break;
                        case 'factory':
                            type = 'factoryfixture_devicegroup';
                            globalCh.request('show_factory_devicegroups', product);
                            break;
                        case 'dut':
                            type = 'dut_devicegroup';
                            globalCh.request('show_dut_devicegroups', product);
                            break;
                        case 'development':
                            type = 'development_devicegroup';
                            globalCh.request('show_development_devicegroups', product, type);
                            break;
                        case 'test_production':
                            type = 'pre_production_devicegroup';
                            globalCh.request('show_pre_production_devicegroups', product);
                            break;
                        case  'test_factory':
                            type = 'test_factoryfixture_devicegroup';
                            globalCh.request('show_pre_factoryfixture_devicegroups',  product);
                            break;
                        case 'test_dut':
                            type = 'test_dut_devicegroup';
                            globalCh.request('show_pre_dut_devicegroups', product);
                            break;
                        default: {
                            self.devicegroup_dashboard(product_id, type);
                        }
                    }
                });
        },
        product_devicegroup: function(product_id, devicegroup_id) {
            var groups = apiCh.request('development_devicegroup');
            var group = groups.find({id: devicegroup_id});
            if (!group) {
                console.warn("Unknown devicegroup id: %s", devicegroup_id);
            }

            var required_data = [
                load_product(product_id),
                load_devicegroup(devicegroup_id)
            ];
            Promise.all(required_data)
                .then(function(data) {
                    globalCh.request('show_devices', { product: data[0], devicegroup: data[1] });
                });
        },
        product_devicegroup_devices: function(product_id, devicegroup_id, device_id) {
            var required_data = [
                load_product(product_id),
                load_devicegroup(devicegroup_id)
            ];

            Promise.all(required_data)
                .then(function(data) {
                    var devicegroup = data[1];
                    if (devicegroup.type === devicegroup.collection.TYPES_MAP.development) {
                        globalCh.request(
                            'show_development_devicegroup_devices',
                            devicegroup
                        );
                    } else if (devicegroup.type === devicegroup.TYPES_MAP.pre_factoryfixture){
                        globalCh.request('show_pre_factoryfixture_devices', devicegroup);
                    } else if (devicegroup.type === devicegroup.collection.TYPES_MAP.production) {
                        globalCh.request(
                            'show_production_devices',
                            devicegroup
                        );
                    } else if (devicegroup.type === devicegroup.collection.TYPES_MAP.factoryfixture) {
                        globalCh.request(
                            'show_factory_devices',
                            devicegroup
                        );
                    } else if (devicegroup.type === devicegroup.collection.TYPES_MAP.pre_production){
                        globalCh.request('show_pre_production_devices', devicegroup);
                    } else {
                        globalCh.request(
                            'show_devices',
                            { product: data[0], devicegroup: data[1] }
                        );
                    }
                });
        },
        invoice: function(username, id) {
            globalCh.request('show_invoice', id);
        },
        my_devices: function() {
            var account = globalCh.request('primary_account');
            ensure_account_loaded_by_name(account.get('username')).then(function(account) {
                globalCh.request('show_my_development_devices', account );
            });
        },
        blinkup: function() {
            var account = globalCh.request('primary_account');
            ensure_account_loaded_by_name(account.get('username')).then(function(account) {
                globalCh.request('show_blinkup');
            });
        },
        account_devices: function(account_name) {
            ensure_account_loaded_by_name(account_name).then(function(account) {
                globalCh.request('show_account_development_devices', account );
            });
        },
        collaborators: function(account_name) {
            ensure_account_loaded_by_name(account_name).then(function() {
                globalCh.request('showCollaboratorList');
            });
        },
        collaborators_profile: function(account_name, collaborator_name) {
            ensure_account_loaded_by_name(account_name).then(function () {
                var accounts = apiCh.request('account');
                var account = accounts.findWhere({ username: account_name });
                var collaborator = accounts.findWhere({ username: collaborator_name });
                if (!collaborator) {
                    return accounts.fetch({
                        data: {
                            'filter[username]': collaborator_name
                        }
                    }).then(()=>{
                        globalCh.request(
                            'show_collaborators_profile',
                            account,
                            accounts.findWhere({ username: collaborator_name }));
                    });
                }
                globalCh.request('show_collaborators_profile', account, collaborator);
            });
        },
        billing: function() {
            var primary = globalCh.request('primary_account');
            ensure_account_loaded_by_name(primary.get('username')).then(function() {
                globalCh.request('show_billing', primary);
            });
        },
        login: function() {
            globalCh.request('login');
        },
        login_keys: function() {
            var primary = globalCh.request('primary_account');
            ensure_account_loaded_by_name(primary.get('username')).then(function () {
                globalCh.request('show_login_keys', primary);
            });
        },
        mfa: function() {
            var primary = globalCh.request('primary_account');
            ensure_account_loaded_by_name(primary.get('username')).then(function () {
                globalCh.request('show_mfa', primary);
            });
        },
        notifications: function() {
            var primary = globalCh.request('primary_account');
            ensure_account_loaded_by_name(primary.get('username')).then(function () {
                globalCh.request('show_notifications_profile', primary);
            });
        },
        reset_password: function(token) {
            globalCh.request('reset_password', token);
        },
        forgot_password: function() {
            globalCh.request('forgot_password');
        },
        verify: function(query) {
            var params = parse_query_params(query);
            globalCh.request('verify', params.hash, params.type);
        },
        not_found: function(path) {
            globalCh.request('notfound_404', path);
        },
        devicegroups: function(product_id) {
            this.product_devicegroups(product_id, 'production_devicegroup');
        },
        find_devicegroup_dashboard: function(devicegroup_id) {
            load_devicegroup(devicegroup_id).then(
                function(devicegroup) {
                    devicegroup.fetch().then(function() {
                        globalCh.request('show_devicegroup_dashboard', devicegroup);
                    });
            });
        },
        devicegroup_dashboard: function(product_id, devicegroup_id) {
            // in case a type has been mistakingly read as an id
            if ( devicegroup_id.match( /(development|test|factory|production)/ ) ) {
                this.product_devicegroups(product_id, devicegroup_id);
                return;
            }
            load_product(product_id)
                .then(function(product) {
                    load_devicegroup(devicegroup_id).then(
                        function(devicegroup) {
                            devicegroup.fetch().then(function() {
                                globalCh.request('show_devicegroup_dashboard', devicegroup, product);
                        });
                    });
                });
        },
        devicegroup_code_history: function(product_id, devicegroup_id) {
            load_product(product_id)
                .then(function(product) {
                    load_devicegroup(devicegroup_id).then(function(devicegroup){
                        globalCh.request('show_devicegroup_code_history', devicegroup, product);
                    });
                });
        },
        devicegroup_draft: function(product_id, devicegroup_id, device_id) {
            var devicegroups = apiCh.request('development_devicegroup');
            var devices =  apiCh.request('device');
            function show_devicegroup_deployment(devicegroup, device){
                devicegroup.draft.fetch();
                if ([
                    'production_devicegroup',
                    'factory_devicegroup',
                   ].indexOf(devicegroup.type) === -1
                ) {
                    if ( device.id === null ) device = undefined;
                    globalCh.request('changeActiveAccount', devicegroup.rel.get('owner'), function(){
                        globalCh.request('showCodeEditor', devicegroup.draft, devicegroup, device);
                    });
                }
            }
            $.when(
                devicegroups.lookup(devicegroup_id),
                devices.lookup(device_id)
            ).done(show_devicegroup_deployment);
        },
        devicegroup_deployment: function(product_id, devicegroup_id, deployment_id, device_id) {
            var devicegroups = apiCh.request('development_devicegroup');
            var deployments = apiCh.request('deployment');
            var devices =  apiCh.request('device');
            function show_devicegroup_deployment(deployment, devicegroup, device){
                if ([
                    'production_devicegroup',
                    'factory_devicegroup'
                   ].indexOf(devicegroup.type) === -1
                ) {
                    if ( device.id === null ) device = undefined;
                    globalCh.request('changeActiveAccount', devicegroup.rel.get('owner'), function(){
                        globalCh.request('showCodeEditor', deployment, devicegroup, device);
                    });
                }
            }
            $.when(
                deployments.lookup(deployment_id),
                devicegroups.lookup(devicegroup_id),
                devices.lookup(device_id)
            ).done(show_devicegroup_deployment);
        },
        factories: function(product_id) {
            load_product(product_id)
                .then(function (product) {
                    globalCh.request('show_factory_devicegroups',  product);
                });
        },
        factory_code_history: function(product_id, devicegroup_id) {
            load_product(product_id)
                .then(function(product) {
                    load_devicegroup(devicegroup_id).then(function(devicegroup){
                        globalCh.request('show_devicegroup_code_history', devicegroup, product);
                    });
                });
        },
        change_email: function(token) {
            var primary = globalCh.request('primary_account');
            ensure_account_loaded_by_name(primary.get('username')).then(function () {
                globalCh.request('home');
                globalCh.request('show_change_email_dialog', primary, token);
            });
        },
    });

    this.router = new IdeRouter(options);
  }
